// extracted by mini-css-extract-plugin
export var circle = "_dr-1";
export var exitConfirmationModal = "_dr-5";
export var iframe = "_dr-0";
export var offline = "_dr-3";
export var online = "_dr-2";
export var workstationSelectError = "_dr-4";